import { Radio, RadioGroup, Stack, FormControl, FormLabel, FormErrorMessage, Text } from "@chakra-ui/react";
import React from "react";

export const RadioInput = ({
	label,
	name,
	value,
	data,
	error,
	touched,
	handleChange,
	size,
	isRequired = false,
	fontWeight = 400,
}) => {
	return (
		<FormControl flex={1} isRequired={isRequired} isInvalid={!!error && touched}>
			<FormLabel htmlFor={name} textTransform={"capitalize"}>
				{label}
			</FormLabel>
			<RadioGroup
				name={name}
				id={name}
				value={value}
				size={size}
				onChange={(val) => handleChange(name, val)}
				colorScheme={"brand"}
			>
				<Stack spacing={4} direction='row'>
					{data.map((item, index) => (
						<Radio key={index} value={item.value}>
							<Text fontWeight={fontWeight}>{item.name}</Text>
						</Radio>
					))}
				</Stack>
			</RadioGroup>
			<FormErrorMessage>{error}</FormErrorMessage>
		</FormControl>
	);
};
